// * ========================================================================
// * Checkout toggle custom orderer info
// * ========================================================================

'use strict';

import $ from 'jquery';

var customOrdererInfo = (function() {
  function init(){


    $('input[name=delivery_address]').on('change', function(){
      //show custom contact info fields
      $('.checkout__delivery-address-form').toggle();

      if($(this).is(':checked')){
        //disable prefilled fields, custom contact info fields are used instead
        $('.js-form__field-prefilled').attr('disabled',true);
        $('.js-form__field-custom-field').attr('disabled',false);
      }
      else {
        //reverse previous
        $('.js-form__field-prefilled').attr('disabled',false);
        $('.js-form__field-custom-field').attr('disabled',true);
      }
    })
  }
  return {
    init: init
  }
})();

module.exports = customOrdererInfo;
